const ADD_TO_BE_CREATED = "ADD_TO_BE_CREATED"
const DELETE_TO_BE_CREATED = "DELETE_TO_BE_CREATED"
const CHANGE_NAME_TO_BE_CREATED = "CHANGE_NAME_TO_BE_CREATED"
const CHANGE_ORDER_TO_BE_CREATED = "CHANGE_ORDER_TO_BE_CREATED"

export {ADD_TO_BE_CREATED, DELETE_TO_BE_CREATED, CHANGE_NAME_TO_BE_CREATED, CHANGE_ORDER_TO_BE_CREATED}